module.exports = __webpack_public_path__ + "static/images/microphone.aa1f5e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wxyy/microphone.png
// module id = wqhY
// module chunks = 6